<template>
  <v-layout row justify-space-between>
    <v-flex v-show="!step.validated">
      <emailSender
        v-if="email"
        :expeditionId="expeditionId"
        :email="email"
        @emailSended="emailSended"
        :stepTemplateId="step.step_template.id"
        :step="step"
      />
      <span v-else>No Email Template has been written in this language</span>
    </v-flex>

    <v-flex v-if="step.validated" class="grey--text text--darken-1">
      <v-layout px-4 wrap row align-center>
        <span class="subheadings">
          <v-icon color="success" class="pr-2" small>mdi-email-check</v-icon>An
          Email has been sent to
          <strong>{{ email.recipient }}</strong>
        </span>
        <v-spacer></v-spacer>
        <v-btn :flat="!show" color="primary" small @click="show = !show">
          <v-icon class="pr-2" small>mdi-email-search</v-icon>
          {{ show ? "Hide " : "View " }}sent mail
        </v-btn>
      </v-layout>

      <v-slide-y-transition>
        <v-card-text v-show="show">
          <v-layout row>
            <v-flex px-2>
              <v-text-field :value="email.cc" label="CC" :disabled="true" />
            </v-flex>
            <v-flex px-2>
              <v-text-field :value="email.bcc" label="BCC" :disabled="true" />
            </v-flex>
          </v-layout>
          <v-subheader>Email Body:</v-subheader>
          <div v-html="email.body"></div>
        </v-card-text>
      </v-slide-y-transition>
    </v-flex>
  </v-layout>
</template>

<script>
import emailSender from "../shared/emailSender";
import date from "../../mixins/date.js";
import { mapGetters } from "vuex";

export default {
  mixins: [date],
  components: {
    emailSender,
  },
  props: {
    expeditionId: {
      type: String,
      required: false,
    },
    step: {
      type: Object,
      required: true,
    },
    actionDone: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const languages = this.fetchLanguages();
    const email = this.fetchEmail(languages[0] && languages[0].id);

    return {
      email: email,
      currentLanguageId: languages[0] && languages[0].id,
      show: false,
    };
  },
  computed: {
    ...mapGetters("commonStore", ["languages"]),
  },
  methods: {
    fetchEmail(languageId) {
      return this.step.emails.find(
        (e) => e.email_template.language_id == languageId
      );
    },
    fetchLanguages() {
      const contract = this.step.expedition
        ? this.step.expedition.contract
        : this.step.contract;
      let languages = this.$store.state.commonStore.languages;
      if (
        this.step.step_template.supplier_type &&
        this.step.step_template.supplier_type.is_product_supplier
      )
        languages = contract.supplier_company.languages;
      if (
        this.step.step_template.supplier_type &&
        !this.step.step_template.supplier_type.is_product_supplier &&
        this.step.expedition
      ) {
        const score_cost = this.step.expedition.score_costs.find(
          (sc) =>
            sc.supplier_type_id == this.step.step_template.supplier_type_id &&
            sc.supplier &&
            sc.supplier.company
        );
        if (score_cost) languages = score_cost.supplier.company.languages;
      }
      if (this.step.step_template.take_language_of_customer)
        languages = contract.customer_company.languages;

      return languages;
    },
    emailSended() {
      this.$emit("update:actionDone", true);
    },
  },
};
</script>
